import { useState, useEffect, useCallback } from 'react';

const IS_MENU_PINNED_KEY = 'gen2.layout.isMenuPinned';
const SIDEBAR_WIDTH_COLLAPSED = 73;
const SIDEBAR_WIDTH_PINNED = 240;

const getWidth = () => {
  const pinned = localStorage.getItem(IS_MENU_PINNED_KEY);
  if (pinned === null) return 0;
  return pinned === 'true' ? SIDEBAR_WIDTH_PINNED : SIDEBAR_WIDTH_COLLAPSED;
};

const useSidebarWidth = () => {
  const [width, setWidth] = useState(getWidth);

  const handleStorageChange = useCallback((e) => {
    if (e.key === IS_MENU_PINNED_KEY) {
      setWidth(e.newValue === 'true' ? SIDEBAR_WIDTH_PINNED : SIDEBAR_WIDTH_COLLAPSED);
    }
  }, []);

  useEffect(() => {
    window.addEventListener('storage', handleStorageChange);

    // Poll for same-tab localStorage changes (storage event only fires cross-tab)
    const interval = setInterval(() => {
      setWidth(getWidth());
    }, 300);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, [handleStorageChange]);

  return width;
};

export default useSidebarWidth;
